'use client'

interface AllsioMarkProps {
  size?: number
  color?: string
  spin?: boolean
  className?: string
}

export default function AllsioMark({ size = 36, color = 'var(--brand-accent)', spin = true, className }: AllsioMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="allsio-orb" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor={color} stopOpacity="0.9"/>
          <stop offset="60%" stopColor={color} stopOpacity="0.3"/>
          <stop offset="100%" stopColor="#000" stopOpacity="0"/>
        </radialGradient>
        <radialGradient id="allsio-core" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="1"/>
          <stop offset="40%" stopColor={color} stopOpacity="0.9"/>
          <stop offset="100%" stopColor="#000" stopOpacity="0"/>
        </radialGradient>
        <filter id="allsio-glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="blur"/>
          <feMerge>
            <feMergeNode in="blur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
        <filter id="allsio-soft" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="6" result="blur"/>
          <feMerge>
            <feMergeNode in="blur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>

      {/* Outer ring */}
      <circle cx="60" cy="60" r="54" fill="none" stroke={color} strokeWidth="0.5" opacity="0.25"/>

      {/* Ambient glow */}
      <circle cx="60" cy="60" r="38" fill="url(#allsio-orb)" filter="url(#allsio-soft)"/>

      {/* Rotating dashed iris ring */}
      <circle
        cx="60" cy="60" r="34"
        fill="none"
        stroke={color}
        strokeWidth="0.8"
        strokeDasharray="4 8"
        opacity="0.5"
        style={spin ? {
          animation: 'allsio-iris-spin 20s linear infinite',
          transformOrigin: '60px 60px',
        } : undefined}
      />

      {/* Inner solid ring */}
      <circle cx="60" cy="60" r="26" fill="none" stroke={color} strokeWidth="1" opacity="0.7"/>

      {/* Core dark fill */}
      <circle cx="60" cy="60" r="22" fill="var(--brand-bg-surface, #0a0f1e)"/>

      {/* Pupil glow */}
      <circle cx="60" cy="60" r="14" fill="url(#allsio-core)" filter="url(#allsio-glow)"/>

      {/* Pupil center */}
      <circle cx="60" cy="60" r="6" fill="#ffffff" opacity="0.95"/>

      {/* Glint */}
      <circle cx="64" cy="56" r="2.5" fill="#ffffff" opacity="0.6"/>

      {/* Cardinal tick marks */}
      <g stroke={color} strokeWidth="1" opacity="0.4">
        <line x1="60" y1="8"   x2="60" y2="16"/>
        <line x1="60" y1="104" x2="60" y2="112"/>
        <line x1="8"  y1="60"  x2="16" y2="60"/>
        <line x1="104" y1="60" x2="112" y2="60"/>
      </g>
    </svg>
  )
}
